import { Navigate, Outlet } from 'react-router-dom';

import { investorRegistrationClosedRoute } from 'constants.ts';
import { Loader } from '@/Components/Loader.tsx';
import { usePublicSettings } from 'Domains/settings/usePublicSettings.ts';

export function InvestorRegistrationGuard() {
    const { investorRegistration, loading } = usePublicSettings();

    if (loading) {
        return <Loader />;
    }

    if (!investorRegistration) {
        return <Navigate to={investorRegistrationClosedRoute} replace />;
    }

    return <Outlet />;
}
